import { render, staticRenderFns } from "./ShipwayIntegration.vue?vue&type=template&id=4014c8f9"
import script from "./ShipwayIntegration.vue?vue&type=script&lang=js"
export * from "./ShipwayIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports